import * as S from './ButtonGoBack.styled';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useUrls } from '~/contexts/url.context';

/**
 * ButtonGoBack Component
 * 
 * Componente de navegação "Voltar" inteligente que:
 * 1. Se houver OnClick customizado, executa primeiro
 * 2. Caso contrário, utiliza o histórico de URLs do contexto
 * 3. Volta para a página anterior mantendo state (filtros, paginação, etc)
 * 4. Se não houver histórico, volta para home
 */
function ButtonGoBack({ OnClick, MarginLeft = '0px' }) {
  const history = useHistory();
  const { obterUrlPaginaAnterior } = useUrls();

  const handleVoltarPadrao = useCallback(() => {
    const { urlBase, queryParam } = obterUrlPaginaAnterior();

    if (urlBase) {
      // Se houver URL anterior no histórico, volta para ela
      history.push({
        pathname: urlBase,
        search: queryParam || '',
      });
    } else {
      // Fallback: volta para home
      history.push('/');
    }
  }, [history, obterUrlPaginaAnterior]);

  const handleClick = () => {
    if (OnClick) {
      // Se houver callback customizado, executa primeiro
      OnClick();
    } else {
      // Caso contrário, usa o comportamento padrão
      handleVoltarPadrao();
    }
  };

  return (
    <>
      <S.ButtonGoBack 
        style={{ marginLeft: MarginLeft }} 
        onClick={handleClick}
      >
        Voltar
      </S.ButtonGoBack>
    </>
  );
}

export default ButtonGoBack;
